<template>
  <el-dialog
      :visible.sync="visible"
      title="添加识别规则"
      width="600px"
      @close="handleClose"
  >
    <el-form :model="formData" label-position="top">
      <el-form-item label="粘贴需要识别的文本内容">
        <el-input
            type="textarea"
            v-model="formData.detectText"
            rows="3"
            placeholder="请输入需要被识别的文本"
            clearable
        />
      </el-form-item>

      <el-form-item label="设定发送规则(选)">
        <el-select
            v-model="formData.deal_names"
            placeholder="勾选规则"
            multiple
            style="min-width: 200px;"
        >
          <el-option
              v-for="item in rules"
              :key="item.key"
              :label="item.key + '=>' + item.value"
              :value="item.key"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="目标机器人">
        <el-select
            v-model="formData.senders"
            filterable
            placeholder="检测指定微信消息"
            multiple
            style="width: 200px"
        >
          <el-option
              v-for="item in room_members"
              :key="item.key"
              :label="item.value"
              :value="item.key"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="触发扣排文本">
        <el-input
            v-model="formData.keyContent"
            placeholder="请输入触发扣排的文本内容"
            clearable
        />
      </el-form-item>

      <el-form-item label="延迟发送时间(ms)">
        <el-select
            v-model="formData.timeoutTime"
            placeholder="Select"
            style="width: 100px"
        >
          <el-option
              v-for="item in timeoutPickers"
              :key="item"
              :label="item"
              :value="item"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "RuleSettingDialog",
  props: {
    visible: Boolean,
    modelValue: Object, // 初始值从父组件传入
  },
  data() {
    return {
      formData: {},
      rules: [], // 可替换为真实数据
      room_members: [],
      timeoutPickers: [0, 1000, 2000, 3000],
    };
  },
  watch: {
    visible(val) {
      if (val && this.modelValue) {
        this.formData = JSON.parse(JSON.stringify(this.modelValue)); // 深拷贝
      }
    },
  },
  methods: {
    confirm() {
      this.$emit("save", this.formData);
      this.$emit("update:visible", false);
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
